// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#main {\r\n  margin-bottom: 30px;\n}\n.page-content {\r\n  padding: 30px;\n}\n.page-content.open {\r\n  margin-left: 118px;\n}\n.blured-body {\r\n  left: 119px;\r\n  top: 100px;\r\n  position: fixed;\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 11;\n}\n.blured-body {\r\n  backdrop-filter: blur(8px);\n}\r\n", ""]);
// Exports
module.exports = exports;
